import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCurrency } from '@/utils/formatters';

export default function PlannedCallout({ planned = [], monthTotal = 0 }) {
  const navigate = useNavigate();
  if (!planned.length) return null;

  return (
    <button
      className="mx-3 mb-3 w-auto text-left rounded-card p-3 border-l-4
                 border-warning bg-warning-light cursor-pointer
                 hover:bg-orange-100 transition-colors block"
      onClick={() => navigate('/planned')}
      aria-label="View planned expenses"
    >
      <p className="text-xs font-bold text-warning">📦 Planned Expenses this month</p>
      <p className="text-xl font-bold text-orange-800 mt-0.5">{formatCurrency(monthTotal)}</p>
      <p className="text-xs text-gray-500 mt-0.5">
        {planned.map(p => p.vendor).join(' · ')} · Not counted in budget
      </p>
    </button>
  );
}
